import React, { useState } from 'react';
import banner1 from "../../assets/banner/banner1.jpg";
import banner from "../../assets/banner/construction-worker-engineer-working-together-construction-site.jpg";
import "./about.css";
import Ourteam from '../ourteam/Ourteam';
import Popup from '../Popup/Popup';
// import Visionmision from '../vission-mission/visionmision';

function Homeabout() {
      const [showPopup, setShowPopup] = useState(false);
    
      const handleEnquiryClick = (e) => {
        e.preventDefault();
        setShowPopup(true);
      };
    
      const handleClosePopup = () => {
        setShowPopup(false);
      };
    

    return (
        <>
            <section className='about-section'>
                <div className='container'>
                    <div className='row'>
                        <div class="col-lg-5">
                            <div class="ttm_single_image-wrapper after-border style2 position-relative ml-20">
                                <img class="img-fluid border-12px-solid white-border" src={banner} title="single-img-five" alt="single-img-five" />
                            </div>
                        </div>
                        <div class="col-lg-7">
                            <div class="spacing-1 ttm-bgcolor-white bordertop-12px-solid skincolor-border">
                                <div class="section-title clearfix">
                                    <div class="title-header">
                                        <h5 style={{ textTransform: "uppercase", color: " #FFA800" }}>About</h5>
                                        <h3>New Sky Property & Projects Private Limited (NSPP)</h3>
                                    </div>
                                    <div className='underline'></div>
                                </div>
                                <p className='p-para'>New Sky Properties is a trusted name in the real estate and construction industry, committed to turning your dreams into lasting landmarks. With a focus on quality, transparency, and customer satisfaction, we specialize in residential, commercial, and land development projects that redefine modern living and investment.</p>
                                <p className='p-para'>Backed by a team of seasoned professionals, we provide end-to-end property solutions — from land acquisition and planning to construction, legal support, and final possession. Every project we undertake is a reflection of our core values: integrity, innovation, and excellence.
                                </p>
                                <form className="d-flex justify-content-center mb-3">
                                    <button className="btn get-button" type="submit"
                                    onClick={handleEnquiryClick}>Get Enquiry</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <Visionmision/> */}
            {/* <Ourteam/> */}
                <Popup show={showPopup} onClose={handleClosePopup} />

        </>
    )
}

export default Homeabout;
